import React, { Component } from 'react';
import * as yup from 'yup'
import { useFormik } from 'formik'

import UserService from 'packages/User/services/UserService';

import PageLoader from 'components/UI/PageLoader';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
		alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  messageBox: {
    width: '100%',
    padding: '15px',
    color: 'white',
    textAlihn: 'center',
    fontSize: '0.875rem',
    borderRadius: '4px',
    '&.error': {
      backgroundColor: 'red',
    },
    '&.success': {
      backgroundColor: 'green',
    }
  },
  messageBoxSuccess: {
    backgroundColor: 'green',
  },
  messageBoxError: {
    backgroundColor: 'red',
  }
}));




const PasswordReset = () => {
  const classes = useStyles();

  const [state, setState] = React.useState({
    email: "",
    message: "",
    code: 200,
    loading: false
  });

  const handleChange = (e) => {
    setState({ 
      ...state,
      [e.target.name]: e.target.value 
    });
  }

  /**
   * Hanlde
   */

  const handleSubmit = () => {
    setState({
      ...state,
      loading: true
    });

    let userService = new UserService();
    userService.passwordReset_emailSend(state.email)
    .then(response => {
      setState({
        email: "",
        message: response.data.message,
        code: 200,
        loading: false
      });
    })
    .catch(error => {
      setState({
        email: "",
        message: error.response.data.message,
        code: 500,
        loading: false
      });
    });
  }

  /**
   * Validate
   */
  const formik =  useFormik({
    initialValues: {
      email: state.email || "",
    },
    validationSchema: yup.object().shape({
      email: yup.string().required('Campo non valido').email("Inserire una mail valida"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit
  })
  
  return (
    <React.Fragment>
      <PageLoader display={state.loading ? 'block' : 'none'}/>
      
      <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Recupera Password
        </Typography>
        <form className={classes.form} onSubmit={formik.handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={formik.values.email}
            onChange={(e)=>{
              handleChange(e)
              formik.handleChange(e)
            }}
            error={formik.errors.email ? true : false}
            helperText={formik.errors.email}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Reset Password
          </Button>
          {state.message && state.message != "" &&
          <Typography component="h1" variant="h5" className={classes.messageBox + ' ' + ((state.code == 200) ? classes.messageBoxSuccess : classes.messageBoxError)}>
            {state.message}
          </Typography>
          }
        </form>
      </div>
    </Container>
  </React.Fragment>
  );

}

export default PasswordReset;